export const TABS_INDEX = {
  COMPANY: 0,
  VEHICLE: 1,
  DRIVER: 2,
  FREIGHT: 3,
  FINAL_DETAILS: 4,
  QUOTES: 5,
};
